module.exports = __webpack_public_path__ + "static/media/4C.7570dd45.jpg";